import { DatePicker, Radio, Row, Skeleton } from "antd";
import React, { FC, useEffect, useState } from "react";
import moment from "moment";
import StudentsIcon from "../../../assets/icons/students.svg";
import LoginsIcon from "../../../assets/icons/logins.svg";
import ActiveUsersIcon from "../../../assets/icons/active-users.svg";
import TimeSpentIcon from "../../../assets/icons/time-spent.svg";
import VideosIcon from "../../../assets/icons/videos.svg";
import PlayIcon from "../../../assets/icons/play.svg";

import QuickQuizIcon from "../../../assets/icons/checklist.svg";

import { DownOutlined } from "@ant-design/icons";
import "./tutorActivities.scss";
import DashboardFilter from "../DashboardFilter";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import { DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import { serialize } from "serializr";
import { _DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/_dashboardFilter.model";
import { defaultFilter, dateFilterFunc } from "../../../shared/utils/filter";
import { TutorActivitiesModel } from "../../../models/DashboardModel/TutorActivitiesModel/tutorActivities.model";
import DownlaodLoginReport from '../DownlaodLoginReport';

interface TutorActivitiesProps { }

const TutorActivities: FC<TutorActivitiesProps> = (props: any) => {
  const { user } = props;
  const [classified, setClassified] = useState("");
  const [tutorActivities, setTutorActivities] = useState<TutorActivitiesModel>({});
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState<DashboardFilterModel>({});
  const fetchTutorActivities = (params?: DashboardFilterModel) => {
    setLoading(true)
    const payload = serialize(_DashboardFilterModel, params ?? {});
    DashboardService.fetchTutorActivities(
      payload,
      (activities) => {
        setTutorActivities(activities);
        setLoading(false);
      },
      () => {
        setLoading(false);
      },
      () => { }
    );
  };

  useEffect(() => {
    if (user?.roleName === 'admin')
      fetchTutorActivities();
  }, []);

  return (
    <div className="student-activities">
      <div className="student-activities__header">
        <div className="student-activities__header-title">
          Tutor Activities{" "}
          <DashboardFilter
            applyHandler={(values) => {
              setFilters(values)
              setClassified("")
              fetchTutorActivities({ ...defaultFilter, ...values })
            }}
            clearHandler={() => {
              setClassified("")
              setFilters({})
              fetchTutorActivities()
            }}
          />
        </div>
        <div className="student-activities__header-classifieds">
          <Radio.Group
            onChange={(e) => {
              setClassified(e?.target?.value);
              if (e?.target?.value !== "month") {
                let dataFilter = dateFilterFunc(e?.target?.value)
                fetchTutorActivities({ ...filters, ...dataFilter })
              }
            }}
            value={classified}
            disabled={(filters?.startingDate || filters?.endingDate) ? true : false}
          >
            <Radio.Button value="today">Today</Radio.Button>
            <Radio.Button value="yesterday">Yesterday</Radio.Button>
            <Radio.Button value="week">Week</Radio.Button>
            <Radio.Button value="month">Month</Radio.Button>
          </Radio.Group>
          {classified == "month" && (
            <DatePicker
              picker={"month"}
              format="MMM YYYY"
              suffixIcon={<DownOutlined />}
              onChange={(e) => {
                let dataFilter = dateFilterFunc(classified, moment(e))
                fetchTutorActivities({ ...filters, ...dataFilter })
              }}
            />
          )}
        </div>
      </div>
      <div className="student-activities-content__container">
        <div className="student-activities-content__card signups">
          <div className="student-activities-content__icon">
            <img src={StudentsIcon} alt="Group Icon" />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Signups</p>
            {loading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{tutorActivities?.totalSignups}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card logins">
          <div className="student-activities-content__icon">
            <img src={LoginsIcon} alt="Login Icon"/>
          </div>
          <div className="student-activities-content__count">
            <p className="title">No. of Logins</p>
            {loading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{tutorActivities?.totalLogins}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card active-users">
          <div className="student-activities-content__icon">
            <img src={ActiveUsersIcon} alt="Active User Icon" />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Active users</p>
            {loading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{tutorActivities?.totalActiveUsers}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card time-spent">
          <div className="student-activities-content__icon">
            <img src={TimeSpentIcon} alt="Not logged in" />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Not Logged In</p>
            <p className="value">{tutorActivities?.notLoggedIn}</p>
          </div>
        </div>
      </div>

      <div className="student-activities-content__container">
        <div className="student-activities-content__card videos">
          <div className="student-activities-content__icon">
            <img src={VideosIcon} alt="Video Icon"/>
          </div>
          <div className="student-activities-content__count">
            <p className="title">Video Views</p>
            {loading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{tutorActivities?.videoViewed}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card pdf">
          <div className="student-activities-content__icon">
            <img src={PlayIcon} alt="Play Icon"/>
          </div>
          <div className="student-activities-content__count">
            <p className="title">Live Class Conducted</p>
            {loading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{tutorActivities?.liveClassesConducted}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card quiz">
          <div className="student-activities-content__icon">
            <img src={QuickQuizIcon} alt="Activities posted"/>
          </div>
          <div className="student-activities-content__count">
            <p className="title">Activities Posted</p>
            {loading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{tutorActivities?.activitiesPosted}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card">
        </div>
      </div>
      <Row className="most__wrapper">
        <DownlaodLoginReport type="tutor" />
      </Row>
    </div>
  );
};

export default TutorActivities;
